import React from 'react';
import PropTypes from 'prop-types';

import LocationSearchContainer from '../LocationSearchContainer';
import LandingPageFooter from '../../../../components/LandingPageFooter';

export class LandingPageFooterContainer extends React.Component {
  validateProps({ heading, locationSearchComponents }) {
    return typeof heading === 'string' && locationSearchComponents;
  }

  componentDidMount() {
    const { heading, locationSearch: locationSearchComponents } = this.props;

    if (
      !this.validateProps({
        heading,
        locationSearchComponents,
      })
    ) {
      throw new Error('Incorrect prop-types for Storyblok LandingPageFooterContainer component');
    }
  }

  render() {
    const { heading, locationSearch: locationSearchComponents } = this.props;

    const locationSearchComponent =
      locationSearchComponents && locationSearchComponents[0] ? (
        <LocationSearchContainer {...locationSearchComponents[0].props} />
      ) : (
        <LocationSearchContainer />
      );

    return <LandingPageFooter heading={heading} locationSearch={locationSearchComponent} />;
  }
}

LandingPageFooterContainer.propTypes = {
  heading: PropTypes.string.isRequired,
  locationSearch: PropTypes.arrayOf(
    PropTypes.shape({
      props: PropTypes.shape({ ...LocationSearchContainer.propTypes }),
    }),
  ),
};

LandingPageFooterContainer.defaultProps = {
  locationSearch: null,
};

export default LandingPageFooterContainer;
